<ngb-alert *ngIf="type === 'warning'" [type]="type" [dismissible]="false" (click)="closeBanner()">
  Your plan expires in less than one month - {{ expirationDate | date : 'MM/dd/yyyy' }},
  <a href="https://www.terminologyhub.com/plans" target="_blank">click here for options</a>
</ngb-alert>
<ngb-alert *ngIf="type === 'danger'" [type]="type" [dismissible]="false" (click)="closeBanner()">
  Your plan has expired. Public projects are still available.
  <a href="https://www.terminologyhub.com/plans" target="_blank">click here for options</a>
</ngb-alert>
<ngb-alert *ngIf="type === 'custom'" [type]="type" [dismissible]="false" (click)="closeBanner()">
  Your plan has technically expired and you are in a 7 day grace period,
  <a href="https://www.terminologyhub.com/plans" target="_blank">click here for options</a>
</ngb-alert>
